// extracted by mini-css-extract-plugin
module.exports = {"nav":"WashingStepperStyles_nav__25ArJ","link":"WashingStepperStyles_link__tp3Tt","current":"WashingStepperStyles_current__rSRZb","done":"WashingStepperStyles_done__2U6Oo"};